import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import {Delete} from '@mui/icons-material'
import NumberFormat from 'react-number-format'
import {fieldtype} from 'utils/enums/fieldtype'
import {rollupFilterRules} from 'utils/enums/rollup'

const Input = React.forwardRef((props, ref) => (
	<TextField variant='standard' ref={ref} {...props} />
))


const Container = styled.div`
    box-sizing: border-box;
    height: 70px;
    align-items: center;
    padding: 0 20px;
    display: flex;
    border: none;
    margin: 0;
    box-shadow: 0 1px 3px 0 rgba(179, 216, 225, .5);
    background: ${props => props.error ? 'rgba(212, 91, 74, 0.25)' : '#FFF'};
`

const Label = styled.span`
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    :not(:first-child) {
        margin: 0 10px;
    }
`

class Item extends React.Component {
    changeRule = (e) => {
        this.props.changeRule(e.target.value, this.props.name, this.props.type)
    }

    render() {
        const conditions = rollupFilterRules[this.props.type]
        const { intl } = this.props

        return (
            <Container error={this.props.error}>
                <Label>{this.props.title}</Label>
                <Select
                    style={{ margin: '0 10px' }}
                    onChange={this.changeRule}
                    value={this.props.rule}
					variant="standard"
                >
                    {Object.keys(conditions).map((item, index) =>
                        <MenuItem key={index} value={conditions[item]}>
                            {intl.formatMessage({id: `filter.rule_${item}`})}
                        </MenuItem>
                    )}
                </Select>
                {(conditions.empty && this.props.rule === conditions.empty) ||
                    this.props.type === fieldtype.check ?
                    <React.Fragment /> :
                    <React.Fragment>
                        {this.props.type === fieldtype.text ?
                            <TextField variant="standard"
                                onChange={(e) => this.props.changeValue(e.target.value, null, this.props.name)}
                                defaultValue={this.props.valueMin || null}
                            />
                            : this.props.type === fieldtype.number ?
                            <React.Fragment>
                                <NumberFormat
                                    customInput={Input}
                                    defaultValue={this.props.config && this.props.config.decimalLength === 0 ? parseInt(this.props.valueMin) : this.props.valueMin}
                                    thousandSeparator=' '
                                    suffix={this.props.config && this.props.config.currencyPosition === 1 && this.props.config.currencySymbol ? ' ' + this.props.config.currencySymbol : ''}
                                    prefix={this.props.config && this.props.config.currencyPosition === 2 && this.props.config.currencySymbol ? this.props.config.currencySymbol + ' ' : ''}
                                    decimalSeparator={this.props.config ? this.props.config.decimalSeparator : ','}
                                    decimalScale={this.props.config ? Number(this.props.config.decimalLength) : 0}
                                    fixedDecimalScale={true}
                                    onValueChange={(value) => this.props.changeValue(value.floatValue, 'min', this.props.name)}
                                />
                                {conditions.between && this.props.rule === conditions.between &&
                                    <React.Fragment>
                                        <Label> and </Label>
                                        <NumberFormat
                                            customInput={Input}
                                            defaultValue={this.props.config && this.props.config.decimalLength === 0 ? parseInt(this.props.valueMax) : this.props.valueMax}
                                            thousandSeparator=' '
                                            suffix={this.props.config && this.props.config.currencyPosition === 1 && this.props.config.currencySymbol ? ' ' + this.props.config.currencySymbol : ''}
                                            prefix={this.props.config && this.props.config.currencyPosition === 2 && this.props.config.currencySymbol ? this.props.config.currencySymbol + ' ' : ''}
                                            decimalSeparator={this.props.config ? this.props.config.decimalSeparator : ','}
                                            decimalScale={this.props.config ? Number(this.props.config.decimalLength) : 0}
                                            fixedDecimalScale={true}
                                            onValueChange={(value) => this.props.changeValue(value.floatValue, 'max', this.props.name)}
                                        />
                                    </React.Fragment>
                                }
                            </React.Fragment>
                            : this.props.type === fieldtype.linkedfield ?
                            <React.Fragment>
                                {!!this.props.options &&
                                    <Select
                                        style={{ minWidth: '100px' }}
                                        onChange={(e) => this.props.changeValue(e.target.value, null, this.props.name)}
                                        value={this.props.valueMin || ''}
										variant="standard"
                                    >
                                        {this.props.options.map((item, index) =>
                                            <MenuItem key={index} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        )}
                                    </Select>
                                }
                            </React.Fragment>
                            :
                            <div />
                        }
                    </React.Fragment>
                }
                <Delete onClick={() => this.props.deleteRule(this.props.name)} style={{ fontSize: 25, marginLeft: 'auto', paddingLeft: '10px', color: '#d45b4a', cursor: 'pointer' }} />
            </Container>
        )
    }
}

export default injectIntl(Item)
